export default function isActive(link, relatedLinks) {
  const { pathname } = window.location;
  return link === pathname ? 'active' : '';
}
